import React from 'react';
import { useSelector } from 'react-redux';

import {
    COLOR_PARENT,
    HEIGHT_ONE_PERCENT,
    ITEM_PARENT_PADDING_TOP,
    ITEM_PARENT_PERCENT_HEIGHT,
    ITEM_PERCENT_PADDING_TOP,
    ITEM_PERCENT_SIZE_ANGLE,
} from '../const';
import { RootState } from '../store';
import { ItemType } from '../types';
import GantItemGradient from './gantItemGradient';
import GantItemListOfGroupTask from './gantItemListOfGroupTask';
import GantItemMarkerBondDrop from './gantItemMarkerBondDrop';
import GantItemSetMarkerBond from './gantItemSetMarkerBond';

interface IGantItemParent {
    propsPath: React.SVGProps<SVGPathElement & SVGRectElement>;

    item: ItemType;
    x: number;
    widthItem: number;
    isOverMouse: boolean;
    accessView: boolean;
    accessEdit: boolean;
}

const GantItemParent: React.FC<IGantItemParent> = ({
    propsPath,
    item,
    accessView,
    x,
    accessEdit,
    widthItem,
    isOverMouse,
}) => {
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);

    const mainParentBox = () => {
        const paddingTop = HEIGHT_ONE_PERCENT * ITEM_PARENT_PADDING_TOP;
        const height = HEIGHT_ONE_PERCENT * ITEM_PARENT_PERCENT_HEIGHT;
        const offsetY = HEIGHT_ONE_PERCENT * ITEM_PERCENT_PADDING_TOP;

        const offsetAngle = HEIGHT_ONE_PERCENT * ITEM_PERCENT_SIZE_ANGLE;

        const outlinePath = `M${x}, ${offsetY + paddingTop}
                       L${x + widthItem},${offsetY + paddingTop}
                       L${x + widthItem},${height + paddingTop}
                       L${widthItem + x - offsetAngle},${height - offsetAngle + paddingTop}
                       L${x + offsetAngle},${height - offsetAngle + paddingTop}
                       L${x},${height + paddingTop}Z`;

        return (
            <g key={item.id}>
                <path {...propsPath} d={outlinePath} fill={`url(#fillStatus-${item.id})`} />
                <GantItemListOfGroupTask item={item} offsetX={x} />
            </g>
        );
    };

    return (
        <g
            style={{
                opacity: accessView || accessEdit ? 1 : 0.5,
                filter: accessView || accessEdit ? 'none' : 'grayscale(100%)',
                transition: 'all 0.3s ease',
            }}
        >
            {accessEdit && <GantItemSetMarkerBond item={item} x={x} widthItem={widthItem} isOverMouse={isOverMouse} />}

            <GantItemGradient
                itemId={item.id}
                percentage={item.completionPercentage}
                color={item.color || COLOR_PARENT}
            />

            {mainParentBox()}
            {item.roleItem !== 'project' && currentDragBond && accessEdit && currentDragBond?.id !== item.id && (
                <>
                    <GantItemMarkerBondDrop item={item} x={x} draggingType={'bondLeft'} />
                    <GantItemMarkerBondDrop item={item} x={x + widthItem} draggingType={'bondRight'} />
                </>
            )}
        </g>
    );
};

export default React.memo(GantItemParent);
